module.exports = __webpack_public_path__ + "img/1698154995410.47f5facb.jpg";